import { useParams, useNavigate } from "react-router-dom";
import { useMe } from "../../auth/MeContext";
import { QuoteComparison } from "./QuoteComparison";

export function QuoteComparisonRoute() {
  const { rfqId } = useParams<{ rfqId: string }>();
  const navigate = useNavigate();
  const me = useMe();
  return (
    <QuoteComparison
      rfqId={rfqId!}
      onBack={() => void navigate("/rfqs")}
      me={me}
    />
  );
}
